<template>
    <div>
      <base-header class="pb-6">
        <div class="row align-items-center py-4">
          <div class="col-lg-6 col-7">
            <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </div>

        </div>
      </base-header>

      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">

            <div class="card">
              <div class="border-0 card-header pb-0">
                 <div class="row justify-content-between">
                  <h3 class="mb-0 col-md-12 col-lg-5 col-xl">Reportes Logs
                    <small class="d-flex">Para generar tu reporte, se deben elegir las fechas de inicio y término.</small>
                  </h3>

                  <div class="col-lg">
                    <div class="row align-items-start justify-content-end mt-sm-3">
                      <base-input addon-left-icon="ni ni-calendar-grid-58" class="col-sm-6 col-md-5">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="{allowInput: true, enableTime: true, dateFormat: 'Y-m-d H:i:S'}"
                                    class="form-control datepicker"
                                    placeholder="Desde"
                                    v-model="dates.inicioRep">
                        </flat-picker>
                      </base-input>

                      <base-input addon-left-icon="ni ni-calendar-grid-58" class="col-sm-6 col-md-5">
                          <flat-picker slot-scope="{focus, blur}"
                                      @on-open="focus"
                                      @on-close="blur"
                                      :config="{allowInput: true, enableTime: true, dateFormat: 'Y-m-d H:i:S'}"
                                      class="form-control datepicker"
                                      placeholder="Hasta"
                                      v-model="dates.finRep">
                          </flat-picker>
                      </base-input>

                      <div class="col-sm-12 col-md-2 mb-3 p-md-0 text-sm-right text-md-center">
                        <base-button type="celcomblue" @click.prevent="obtenerLista()">Filtrar</base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-between">
                <div v-show="reporteLoad">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div v-show="reporteLoad">
                  <base-input v-model="keySearch"
                              prepend-icon="fas fa-search"
                              placeholder="Buscar..."
                              class="mb-3">
                  </base-input>
                </div>
              </div>

              <div class="col-12">
                <el-table class="table-responsive table-flush table-striped"
                        header-row-class-name="thead-light"
                        :data="queriedData">
                  <el-table-column label="Cliente"
                                   prop="customer"
                                   min-width="100px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  {{row.customer}}
                              </div>
                          </div>
                      </template>
                  </el-table-column>



                  <el-table-column label="Campaña"
                                   prop="sendingName"
                                   min-width="100px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  {{row.sendingName}}
                              </div>
                          </div>
                      </template>
                  </el-table-column>


                  <el-table-column label="Descripcion"
                                   prop="shortName"
                                   min-width="250px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  {{row.shortName}}
                              </div>
                          </div>
                      </template>
                  </el-table-column>


                  <el-table-column label="Fecha"
                                   prop="sendingDate"
                                   min-width="100px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  {{fechaFormato(row.sendingDate)}}
                              </div>
                          </div>
                      </template>
                  </el-table-column>


                  <el-table-column label="Posicion"
                                   prop="sendingPosition"
                                   min-width="100px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  {{row.sendingPosition}}
                              </div>
                          </div>
                      </template>
                  </el-table-column>


                  <el-table-column label="Total"
                                   prop="sendingTotal"
                                   min-width="100px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  {{row.sendingTotal}}
                              </div>
                          </div>
                      </template>
                  </el-table-column>


                </el-table>

                <div
                  slot="footer"
                  class="col-12 mt-4 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class="">
                      <small class="card-category">
                        Mostrando {{ from + 1 }} de {{ to }}  -  {{ total }} entradas

                        <span v-if="selectedRows.length">
                          &nbsp; &nbsp; {{selectedRows.length}} rows selected
                        </span>
                      </small>

                    </div>
                    <base-pagination
                      class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="total"
                    >
                    </base-pagination>
                </div>

                <div class="d-flex justify-content-end">
                  <base-button type="celcompink" class="my-3" v-show="reporteLoad" @click.prevent="descargarReport(tableData)">
                    <i class="fas fa-download"></i> Descargar Reportes
                  </base-button>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

  </div>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui'
  import { BasePagination, Modal, Dialog } from '@/components';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload';
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  flatpickr.localize(Spanish);
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  import moment from 'moment';
  import XLSX from 'xlsx';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';

  import swal from 'sweetalert2';
  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora,search_data, onPermissionsUser,getUserSub } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)

  export default {
    mixins: [clientPaginationMixin],
    components: {
      DropzoneFileUpload,
      BasePagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      Modal,
      Dialog,
      flatPicker
    },
    data() {
      return {
        currentPage: 1,
        tableData: [],
        listaContactos: [],
        selectedRows: [],
        listaNombre: "",
        contactGroup: {},
        contactSingle: {},
        dates: {
          inicioRep: horaAhora(),
          finRep: horaAhora()
        },
        fileSingle: [],
        reporteLoad: false,
        keySearch:""
      };
    },

     watch: {

      'keySearch'(newVal){
          if(newVal.toString().length>3){
            this.searchedData = search_data(newVal, this.tableData);
          }else{
            this.searchedData = this.tableData;
          }
      },

    },
    methods: {

     obtenerLista() {

      this.$loading.show()   //delay default is 300ms

      let self = this;
       let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "start_date":moment(this.dates.inicioRep).valueOf().toString(),
        "end_date":moment(this.dates.finRep).valueOf().toString(),
        "global_report":false,
        "time_expired":horaAhora(),
        "customer_user":encodeURIComponent(JSON.stringify(user)),
      }

      console.log(js);

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.report_log, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {
              console.log(response.data.data);


            if(response.data.data.length>0){
              self.reporteLoad = true;
            }
              self.tableData = response.data.data.sort((a, b) => (a.idSending < b.idSending) ? 1 : -1);

            } else {
              console.log("No se encontraron registros");
              swal({
                title: 'No se encontraron registros',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontraron registros",error);
            swal({
                title: 'No se encontraron registros',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
            })
            self.$loading.hide();
        });

      },
      descargarReportSingle(row) {

      this.$loading.show()   //delay default is 300ms

      let self = this;
       let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "start_date":moment(this.dates.inicioRep).format('YYYY-MM-DD').toString(),
        "sendingsms_id":row.sendingSmsId.toString(),
        "report_name":row.sendingName,
        "time_expired":horaAhora(),
      }

      console.log(js);

      window.open(Config.url_service+Config.report_excel_report + encodeURIComponent(encryptAES(js)))

      self.$loading.hide()

      },
      fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD HH:mm:ss');
      },
      descargarReport() {

        var tbl = this.tableData;
        var ws = XLSX.utils.json_to_sheet(tbl);

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Reporte MT");

        XLSX.writeFile(wb, 'ReporteMT.xlsx');

      }
    },
    mounted() {

      if(!onPermissionsUser('report.xhtml', 'view')) {
        swal({
          title: 'No tienes los permisos para acceder a esta página.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          type: 'error',
          }).then(function() {
            window.location.href="/dashboard";
        })

      }

      this.obtenerLista();

    },
    create() {
      this.$loading.show();
    },
    computed: {

    }
  }
</script>

<style>
.modal-secondary .close > span:not(.sr-only) {
  color: #172b4d;
}
.busy-mask {
  z-index: 1051;
}
</style>
